package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_04_26_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-04-26")
@Composable
public fun Log_2024_04_26(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Subterranean Cavern",
        ogTitle = "Subterranean Cavern",
        date = LocalDate(2_024, 4, 26),
        ogDescription = "The heroes descend into a subterranean cavern, triggering traps and engaging Hezrou warriors in the depths.",
        ogImage = "ai/2024-04-26.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-51", dateString = "Newgrowth 51")
        Log_2024_04_26_Day_1()
    }
}
